export const kamon_addresses = {
  decoderAddress:"0xAa37fA6cEb855500E269513cA9e6E5F13B4D0D95",
  kamonAddress:"0x0259F141Af3FE5Fd7632D927291060e1B841e8BD"
}
